import React, { forwardRef, Ref } from 'react'

import { MergeProps } from 'component-library-next/types/types'

import { IntlMessageKeys, useIntl } from '@app/intl/Intl'
import { Select, SelectProps } from '@app/lib/inputs/Select'
import {
  CourtCasesFilterValues,
  CourtCasesStateFilterValues
} from '@app/modules/CourtCasesTables/hooks/useCourtCasesTable'

type Props = MergeProps<
  Omit<SelectProps<CourtCasesFilterValues['state']>, 'options'>,
  {
    name?: string
    disabled?: boolean
    placeholder?: string
    value?: CourtCasesFilterValues['state']
    onChange: (state?: CourtCasesFilterValues['state']) => void | Promise<void>
  }
>

export const CourtCaseStatePicker = forwardRef(
  (
    { name, disabled, placeholder, value, onChange, ...rest }: Props,
    ref: Ref<HTMLButtonElement>
  ) => {
    const { formatMessage } = useIntl()

    const validStates = CourtCasesStateFilterValues.map((value) => ({
      value,
      label: formatMessage({ id: `CourtCaseState.${value}` as IntlMessageKeys })
    }))

    return (
      <Select
        {...rest}
        triggerSize='sm'
        ref={ref}
        name={name}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        options={validStates}
        onChange={onChange}
      />
    )
  }
)
